import React, { useEffect } from "react";
import { CMSSections } from "./CMSBlockRenderer";
import { useSite, resolveAssetUrl } from "../context/SiteContext";
import { useLanguage } from "../context/LanguageContext";
import { applySeo, getBuiltinSeo } from "../lib/seo";

const CmsAwarePage = ({ slug, children }) => {
  const { pagesBySlug, settings } = useSite();
  const { lang } = useLanguage();
  const page = pagesBySlug?.[slug];
  const sections = page?.published_sections || [];

  useEffect(() => {
    const seo = page?.published_seo || {};
    const globalSeo = settings?.seo || {};
    const fallbackSeo = getBuiltinSeo(slug, lang) || {};
    const title = seo?.[`title_${lang}`] || fallbackSeo.title || globalSeo?.[`default_title_${lang}`] || "TowerLink Platform";
    const desc = seo?.[`description_${lang}`] || fallbackSeo.description || globalSeo?.[`default_description_${lang}`] || "";
    const ogImage = resolveAssetUrl(seo?.og_image_url || globalSeo?.og_image_url || "");

    applySeo({
      title,
      description: desc,
      pathname: window.location.pathname,
      lang,
      image: ogImage,
      robots: page?.enabled === false ? "noindex,nofollow" : "index,follow",
    });
  }, [page, settings, lang, slug]);

  if (page && page.enabled === false) return <div className="min-h-[70vh] pt-40 text-center px-6"><h1 className="font-heading text-4xl font-bold">404</h1><p className="text-slate-400 mt-3">{lang === "ar" ? "هذه الصفحة غير متاحة حاليًا" : "This page is currently unavailable"}</p></div>;
  if (page?.mode === "replace") return <CMSSections sections={sections} />;
  if (page?.placement === "before" && sections.length) return <><CMSSections sections={sections} />{children}</>;
  return <>{children}{sections.length > 0 && <CMSSections sections={sections} />}</>;
};

export default CmsAwarePage;
